"use client";

import Link from "next/link";
import { selectIsUserLoggedIn } from "stores/auth/authSlice";
import { useAppSelector } from "stores/hooks";
export const APPLY_URL = "/signup";
const ReadyToGetStartedSection = () => {
  const isLoggedIn = useAppSelector(selectIsUserLoggedIn);
  if (isLoggedIn) return null;
  return <section className='flex flex-col items-center gap-6 px-[60px] py-10 text-center md:px-[100px] md:py-[70px]' data-sentry-component="ReadyToGetStartedSection" data-sentry-source-file="ReadyToGetStartedSection.tsx">
      <h2 className='font-wasgaten text-[30px] leading-[1.2] tracking-[-0.015em] text-secondary-500 md:text-[42px]'>
        Ready to get started?
      </h2>

      <p className='text-[15px] leading-[1.1] text-brand-dark md:text-[25px]'>
        Apply for access to Signature Stay Collection today
      </p>

      <Link href={APPLY_URL} className='flex h-11 w-[219px] items-center justify-center rounded-[20px] bg-primary-500 text-xl font-medium leading-[1.1] text-white' data-sentry-element="Link" data-sentry-source-file="ReadyToGetStartedSection.tsx">
        Apply now
      </Link>
    </section>;
};
export default ReadyToGetStartedSection;